import 'antd/dist/antd.css';
import './assets/index.css';

import React, { useLayoutEffect } from 'react';
import ReactDOM from 'react-dom/client';

import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';

import AppRoute from './utils/routes';
import ProtectedRoutes from "./utils/protectedRoutes";
import AuthProtectedRoutes from "./utils/AuthProtectedRoute";

import Homepage from './components/homepage/index';
// import Homepage from './components/homepage/cover';

import Shop from './components/shop/index';
import Chairs from './components/shop/chairs';
import Tables from './components/shop/tables';
import Benches from './components/shop/benches';
import ProductDetail from './components/shop/product_detail';
import Checkout from './components/shop/checkout';
import About from './components/mini/about';
import Portfolio from './components/mini/portfolio';
import Contact from './components/mini/contact';
import Privacy from './components/mini/privacy';
import ReturnsPolicy from './components/mini/returns_policy';
import FAQs from './components/mini/faqs';
import SignIn from './components/auth/signin';
import SignUp from './components/auth/signup';
import Blog from './components/mini/blog';
import Terms from './components/mini/terms';

import Dashboard from './components/profile/dashboard';
import DeliveryDetails from './components/profile/deliverydetails';
import TransactionHistory from './components/profile/orders';
import SavedItems from './components/profile/saved';
import SignOut from './components/profile/signout';
import Cart from './components/shop/cart';
import BlogTopic1 from './components/mini/blog/designing';
import BlogTopic2 from './components/mini/blog/wooden';
import SingleProduct from './components/shop/product';
import AllProducts from './components/shop/allproducts';

const Wrapper = ({ children }) => {
    const location = useLocation();
    useLayoutEffect(() => {
        document.documentElement.scrollTo(0, 0);
    }, [location.pathname]);
    return children
}

const App = () => {
    return (
        <BrowserRouter>
            <Wrapper>
                <Routes>
                    <Route path="/" exact element={<Homepage />} />
                    <Route path={AppRoute.shop} element={<Shop />} />
                    <Route path="/products/:categoryName" element={<SingleProduct />} />
                    <Route path="/allproducts" element={<AllProducts />} />
                    <Route path="/sofa" element={<Chairs />} />
                    <Route path="/tables" element={<Tables />} />
                    <Route path="/benches" element={<Benches />} />
                    <Route path={AppRoute.product_detail} element={<ProductDetail />} />
                    <Route path={AppRoute.checkout} element={<Checkout />} />
                    <Route path={AppRoute.story} element={<About />} />
                    <Route path={AppRoute.contact_us} element={<Contact />} />
                    <Route path={AppRoute.privacy_policy} element={<Privacy />} />
                    <Route path={AppRoute.returns_policy} element={<ReturnsPolicy />} />
                    <Route path={AppRoute.faqs} element={<FAQs />} />
                    <Route path={AppRoute.terms} element={<Terms />} />

                    <Route path={AppRoute.cart} element={<Cart />} />
                    <Route path="/portfolio" element={<Portfolio />} />
                    <Route path={AppRoute.blog} element={<Blog />} />
                    <Route path="/blogspot/designing-your-outdoor-space" element={<BlogTopic1 />} />
                    <Route path="/blogspot/5-ways-to-use-or-repurpose-wooden-crates" element={<BlogTopic2 />} />

                    {/* auth */}
                    <Route path="/signin" element={<AuthProtectedRoutes><SignIn /></AuthProtectedRoutes>} />
                    <Route path="/signup" element={<AuthProtectedRoutes><SignUp /></AuthProtectedRoutes>} />
                    <Route path="/signout" element={<AuthProtectedRoutes><SignOut /></AuthProtectedRoutes>} />

                    {/* profile */}
                    <Route path={AppRoute.profile_dashboard} exact element={<ProtectedRoutes><Dashboard /></ProtectedRoutes>} />
                    <Route path={AppRoute.profile_delivery_details} exact element={<ProtectedRoutes><DeliveryDetails /></ProtectedRoutes>} />
                    <Route path={AppRoute.profile_orders} exact element={<ProtectedRoutes><TransactionHistory /></ProtectedRoutes>} />
                    <Route path={AppRoute.profile_saved_items} exact element={<ProtectedRoutes><SavedItems /></ProtectedRoutes>} />
                </Routes>
            </Wrapper>
        </BrowserRouter>
    )
};

export default App;